const defaultError = 'error';

const errorsDictionary = {
  // https://github.com/tvoli/playback/blob/master/doc/error-codes.md
  520: 'playerError.noSubscription',
  521: 'playerError.countryPermission',
  522: 'playerError.trafficOverload',
  523: 'playerError.upgradeSubscription',
  530: 'playerError.notAvailable',
  531: 'playerError.noLongerAvailable',
  532: 'playerError.anotherPlayer',
  533: 'playerError.anotherPlayer',
  534: 'playerError.noLongerAvailable',
  535: 'playerError.anotherPlayer',
  536: 'playerError.anotherPlayer',
  537: 'playerError.verifyEmail',
  538: 'playerError.verifyEmail',
  539: 'playerError.anotherPlayer',
  545: 'playerError.cannotChromecast',
  546: 'playerError.tooManyDevices',
  547: 'playerError.enterPostcode',
  548: 'playerError.wrongRegion',
  549: 'playerError.noDRM',
  550: 'playerError.notAvailable',
  551: 'playerError.notAvailable',
  552: 'playerError.noLiveRights',
  553: 'playerError.forbiddenProxy',
  605: 'playerError.noDRM',
  606: 'playerError.browser',

  666: 'playerError.adblockerDetected',

  // Template app errors. To be used when it makes sense to show a message on
  // the player error message overlay but the error code does not originate
  // from the player.
  800: 'playerError.entitlementUnauthorized',

  // Fallback error message
  768: defaultError,

  // RTL HD license rejection on Chrome and Firefox
  4012: (error) => {
    // detect if playback was denied on external monitor
    if (error.data[0]?.restrictedKeyStatuses?.includes('output-restricted')) {
      return {
        message: 'playerError.outputRestricted',
      };
    }

    return {
      message: 'playerError.licenseRejected',
    };
  },
  6008: 'playerError.licenseRejected',

  1001: error => ({
    message: 'playerError.serverError',
    values: {
      code: error.data[1],
    },
  }),
  1002: 'playerError.networkError',
};

export function getErrorMessage(code, error) {
  const errorFromDictionary = errorsDictionary[code] || defaultError;

  if (typeof errorFromDictionary === 'string') {
    return {
      message: errorFromDictionary,
    };
  }

  if (typeof errorFromDictionary === 'function') {
    return errorFromDictionary(error);
  }

  throw new Error(`Error entry for code ${code} is not currently supported. Expected string or function`);
}
